/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_DisclaimerInputs */

const en_salary_disclaimer = /** @type {(inputs: Salary_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salary data is AI-generated and may not reflect exact market conditions. Use as a starting point for research.`)
};

const de_salary_disclaimer = /** @type {(inputs: Salary_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gehaltsdaten sind KI-generiert und spiegeln möglicherweise nicht die exakten Marktbedingungen wider. Verwende sie als Ausgangspunkt für deine Recherche.`)
};

const fr_salary_disclaimer = /** @type {(inputs: Salary_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les données salariales sont générées par l'IA et peuvent ne pas refléter les conditions exactes du marché. Utilise-les comme point de départ pour tes recherches.`)
};

const es_salary_disclaimer = /** @type {(inputs: Salary_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los datos salariales son generados por IA y pueden no reflejar las condiciones exactas del mercado. Utilícelos como punto de partida para su investigación.`)
};

const it_salary_disclaimer = /** @type {(inputs: Salary_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I dati salariali sono generati dall'AI e potrebbero non riflettere le condizioni esatte del mercato. Usali come punto di partenza per la ricerca.`)
};

const nl_salary_disclaimer = /** @type {(inputs: Salary_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salarisgegevens zijn AI-gegenereerd en weerspiegelen mogelijk niet de exacte marktomstandigheden. Gebruik als startpunt voor onderzoek.`)
};

const pl_salary_disclaimer = /** @type {(inputs: Salary_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dane o wynagrodzeniach są generowane przez AI i mogą nie odzwierciedlać dokładnych warunków rynkowych. Traktuj je jako punkt wyjścia do badań.`)
};

const fi_salary_disclaimer = /** @type {(inputs: Salary_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palkkatiedot ovat tekoälyn tuottamia eivätkä välttämättä vastaa tarkkoja markkinaolosuhteita. Käytä lähtökohtana tutkimukselle.`)
};

const da_salary_disclaimer = /** @type {(inputs: Salary_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Løndata er AI-genereret og afspejler muligvis ikke de nøjagtige markedsforhold. Brug som udgangspunkt for research.`)
};

const sv_salary_disclaimer = /** @type {(inputs: Salary_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lönedata är AI-genererade och kanske inte speglar exakta marknadsförhållanden. Använd som utgångspunkt för research.`)
};

/**
* | output |
* | --- |
* | "Salary data is AI-generated and may not reflect exact market conditions. Use as a starting point for research." |
*
* @param {Salary_DisclaimerInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_disclaimer = /** @type {((inputs?: Salary_DisclaimerInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_DisclaimerInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_disclaimer(inputs)
	if (locale === "fr") return fr_salary_disclaimer(inputs)
	if (locale === "es") return es_salary_disclaimer(inputs)
	if (locale === "it") return it_salary_disclaimer(inputs)
	if (locale === "nl") return nl_salary_disclaimer(inputs)
	if (locale === "pl") return pl_salary_disclaimer(inputs)
	if (locale === "fi") return fi_salary_disclaimer(inputs)
	if (locale === "da") return da_salary_disclaimer(inputs)
	if (locale === "sv") return sv_salary_disclaimer(inputs)
	return en_salary_disclaimer(inputs)
});